import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Fullscreen } from "../Components/styled/Image";
import { MainHome, HomeBox, Column } from "../Components/styled/Layout";
import space from "../assets/images/space2.jpg";
import { Title, Subtitle } from "../Components/Typo";
import { Paragraph } from "../Components/styled/Typo";
import { BlockButton, NextButton } from "../Components/styled/Button";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

export default function Universe() {
  const { t } = useTranslation();
  return (
    <motion.div
      className="container"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 1, x: -100, transition: { duration: 0.1 } }}
    >
      <BlurMainHome>
        <Fullscreen src={space} />
        <HomeBoxFull>
          <HomeColumn>
            <Title style={{ color: "#fff" }}>{t("universTitle")}</Title>
            <Paragraph style={{ fontSize: "1rem", color: "#fff" }}>
              {t("universContent")}
            </Paragraph>
            <br />
            <BlockButton>
              <NextButton to={"/"}>
                <FaAngleLeft />
              </NextButton>
              <NextButton to={"/human"}>
                <FaAngleRight />
              </NextButton>
            </BlockButton>
          </HomeColumn>
        </HomeBoxFull>
      </BlurMainHome>
    </motion.div>
  );
}

const HomeColumn = styled(Column)`
  justify-content: center;
  align-items: center;
  width: 500px;
  height: auto;
  background: #f6f6f633;
  backdrop-filter: blur(25px);
  /* position: absolute;
  top: 50%;
  right: 50px;
  transform: translateY(-50%); */
  border-radius: 5px;
  overflow: hidden;
  padding: 40px;
`;

const HomeBoxFull = styled(HomeBox)`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 50px;
`;

const BlurMainHome = styled(MainHome)`
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #000;
    opacity: 0.2;
  }
`;
